import { TFnType, useTranslate } from '@tolgee/react';
/**
 * Maps subject abbreviations to sentence-friendly display names.
 * Use this when you need a subject rendered in the middle of a sentence.
 */
export const formatSubjectForSentence = (
  subject: string | number | boolean | undefined,
): string | undefined => {
  if (!subject) return undefined;

  const subjectString = String(subject)
    .toLowerCase()
    .trim();

  const subjectMap: Record<string, string> = {
    ela: 'English',
    math: 'math',
    science: 'science',
    social_studies: 'social studies',
    socialstudies: 'social studies',
    world_languages: 'world languages',
    worldlanguages: 'world languages',
    mental_health: 'mental health',
    mentalhealth: 'mental health',
    other: '',
  };

  return subjectMap[subjectString] || String(subject);
};

/**
 * Maps subject abbreviations to localized sentence-friendly display names.
 * Use this when you need a subject rendered in the middle of a sentence with i18n support.
 */
export function useFormatLocalizedSubjectForSentence(
  subject: string | number | boolean | undefined,
): string | undefined {
  const { t } = useTranslate();
  if (!subject) return undefined;
  const subjectString = String(subject)
    .toLowerCase()
    .trim();

  const subjectMap: Record<string, string> = {
    ela: t('subject.ela', 'English'),
    math: t('subject.math', 'math'),
    science: t('subject.science', 'science'),
    social_studies: t('subject.socialStudies', 'social studies'),
    socialstudies: t('subject.socialStudies', 'social studies'),
    world_languages: t('subject.worldLanguages', 'world languages'),
    worldlanguages: t('subject.worldLanguages', 'world languages'),
    mental_health: t('subject.mentalHealth', 'mental health'),
    mentalhealth: t('subject.mentalHealth', 'mental health'),
    other: '',
  };

  return subjectMap[subjectString] ?? String(subject);
}
